export default __webpack_public_path__ + "static/media/Content Creating.b14512b5.png";